import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    r("circle", {
      cx: "12",
      cy: "12",
      r: "7.5",
      stroke: "currentColor"
    }, null, -1),
    r("path", {
      stroke: "currentColor",
      d: "M12 8v8m4.005-4.005h-8"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
